module.exports = __webpack_public_path__ + "static/media/fireplace.5f2cc1b3.svg";